<div class="tab {{cssClass}}" [routerLink]="routerLink" [routerLinkActive]="['active']"
  (click)="clickOnTab.emit()">
  <span *ngIf="tabOrderNumber > 0" class="tab-order">{{tabOrderNumber}}</span>
  <div class="tab-icon hide-on-sticky">
    <span *ngIf="hasSubmitValidationError && progress !== undefined && progress !== 100" class="tab-error-exclamation-mark"></span>
  </div>

  <div class="title" [ngClass]="{'title-tab--incomplete': hasSubmitValidationError && progress !== undefined  && progress !== 100}">{{ label }}</div>
  <div class="progress-bar">
    <div class="progress-bar-value" [ngClass]="{'uncomplete': hasSubmitValidationError && progress !== undefined  && progress !== 100}"
      [ngStyle]="{'width.%': progress !== undefined ? progress : 0}">
    </div>
  </div>
</div>